import { Card } from '@mantine/core';
import { IconListDetails } from '@tabler/icons-react';
import { SectionProps, Section } from './Section';
import { useGetModalSectionBorderColor } from 'hooks/useGetModalSectionBorderColor';

export const ClaimDetailSection = ({
  index,
  title,
  keys,
  cols,
  editComponentsMap,
  type = 'edit',
}: SectionProps) => {
  const borderColor = useGetModalSectionBorderColor({
    keys,
  });
  return (
    <Card
      padding={'md'}
      shadow="xs"
      radius="md"
      withBorder
      style={{ borderColor: borderColor }}
      data-testid={'claim-detail-section'}
    >
      <Section
        index={index}
        title={title}
        icon={<IconListDetails size={20} />}
        keys={keys}
        cols={cols}
        grow={true}
        editComponentsMap={editComponentsMap}
        type={type}
      />
    </Card>
  );
};
